/**
 * Returns the local time zone of the user's system.
 * @returns {string} The IANA time zone identifier.
 */
export const getLocalTimeZone = (): string =>
  // format = "IANA"
  // https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
  Intl.DateTimeFormat().resolvedOptions().timeZone;
